<template>
    <b-container fluid>
        <hr/>
        <h3>Users index</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_user_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New user
            </v-btn>
        </b-button-group>
        <hr/>

        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="users"
                     :fields="['id', 'firstname', 'lastname', 'email', 'roles', 'edit', 'change_password', 'delete']">
                <template slot="roles" slot-scope="data">
                    {{formatList(data.item.roles)}}
                </template>
                <template slot="edit" slot-scope="data">
                    <b-button @click="edit_user(data.item)" variant="primary">Edit</b-button>
                </template>
                <template slot="change_password" slot-scope="data">
                    <b-button @click="change_password(data.item)" variant="secondary">Change password</b-button>
                </template>
                <template slot="delete" slot-scope="data">
                    <b-button @click="delete_user(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <create-user @user-created="user_created"
                     @change-create-loading="loadingCreate = !loadingCreate">
        </create-user>
        <edit-user v-bind:selected_user="to_edit_user"
                   @user-edited="user_edited"
                   @show-loading-pop-up="showLoadingPopUp"
                   @reset-loading-pop-up="resetLoadingPopUp">
        </edit-user>
        <edit-password v-bind:user_id="to_edit_user.id"
                       @show-loading-pop-up="showLoadingPopUp"
                       @reset-loading-pop-up="resetLoadingPopUp">
        </edit-password>
    </b-container>
</template>

<script>
    import UserRepository from '../../repositories/user.repository';
    import CreateUser from './Create.vue';
    import EditUser from './Edit.vue';
    import EditPassword from "./EditPassword";

    export default {
        components: {
            CreateUser,
            EditUser,
            EditPassword,
        },
        data() {
            return {
                to_edit_user: UserRepository.blankUser(),
                users: [],
                loadingIndex: false,
                loadingCreate: false,
            }
        },
        created() {
            this.loadingIndex = true;
            UserRepository.getAll().then(res => {
                this.users = res.data["hydra:member"];
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false;
            });
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            formatList(list) {
                let string = "";
                for (let i = 0; i < list.length; i++) {
                    string = string + (i === 0 ? "" : ", ") + list[i];
                }
                return string;
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            change_password(data) {
                this.to_edit_user = Object.assign({}, data);
                this.$bvModal.show('edit_password_modal');
            },
            user_created(user) {
                this.users.push(user);
                this.loadingCreateUser = false;
            },
            user_edited(user) {
                this.users.forEach(u => {
                    if (u.id === user.id) Object.assign(u, user);
                });
            },
            edit_user(data) {
                // Clone the selected item so that it can be edited without changing the original.
                this.to_edit_user = Object.assign({}, data);
                // Show the edit modal.
                this.$bvModal.show('edit_user_modal');
            },
            delete_user(data) {
                // this.loadingPopUp = {loading: true, text: 'DeletingUser'};
                this.$emit('show-loading-pop-up', 'Deleting the selected user.');
                UserRepository.delete(data.id).then(res => {
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        this.$emit('reset-loading-pop-up');
                        // Remove the user from the local list to reflect the deletion.
                        this.users = this.users.filter(u => u.id !== data.id);
                        // Notify the user.
                        this.$bvToast.toast(`User ${data.firstname + ' ' + data.lastname} successfully deleted.`, {
                            title: `User deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$emit('reset-loading-pop-up');
                        this.$bvToast.toast('Looks like something went wrong while deleting a user.', {
                            title: `User deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                });
            }
        }
    }
</script>
